import { render } from "./DocumentationProductPage.vue?vue&type=template&id=64991aeb&scoped=true"
import script from "./DocumentationProductPage.vue?vue&type=script&lang=js"
export * from "./DocumentationProductPage.vue?vue&type=script&lang=js"

import "./DocumentationProductPage.vue?vue&type=style&index=0&id=64991aeb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64991aeb"]])

export default __exports__